// extracted by mini-css-extract-plugin
module.exports =  {"keyword":"keyword__64zok","lastCol":"lastCol__qq1YO"};